// App-wide API base (Vue.prototype.$baseUrl, set in main.js) -- used by
// ~140 authenticated call sites across the app. Extracted into its own tiny,
// side-effect-free module so this one assignment is independently unit-
// testable without importing all of main.js's heavy side effects (router,
// store, vuetify, axios interceptors, ...).
//
// Same rule as the Customer Display's own direct-call base
// (src/views/pages/customer-display/apiBaseUrl.js): the production fallback
// (no VUE_APP_API_BASE_URL set) must be the production API, never dev-api,
// even temporarily -- nothing distinguishes "someone forgot to set the env
// var" from "this really is production" once an authenticated request
// actually reaches the wrong backend. A dev/local build that wants dev-api
// sets VUE_APP_API_BASE_URL itself, e.g. via a gitignored
// .env.development.local (see that file in this repo) -- never by editing
// this fallback.
const FALLBACK_BASE_URL = 'https://api.permtang.com';

// Pure, directly testable: takes the raw env value as an explicit argument
// rather than reading process.env internally. A test that instead tries to
// exercise this resolution rule by re-requiring this module with a mutated
// process.env.VUE_APP_API_BASE_URL (jest.resetModules() + require()) can be
// affected by whatever this project's Babel/Jest transform pipeline does
// with that same env var at TRANSFORM time (independently of the test's own
// runtime process.env mutation) when a local .env.development.local sets
// it -- see tests/baseUrl.spec.js. Calling this function directly sidesteps
// that path entirely: there is no module reload and no process.env read
// involved in the test at all, only the resolution rule itself.
export function resolveBaseUrl(envValue) {
  return envValue || FALLBACK_BASE_URL;
}

export const BASE_URL = resolveBaseUrl(process.env.VUE_APP_API_BASE_URL);
